import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import auth, { storeStateInSessionStorage } from '../../utils/auth';
import CallbackSpinner from '../views/CallbackSpinner';

const NotSignedIn = ({ history, forceLogin }) => {
  useEffect(() => {
    const checkAuth = async () => {
      if (forceLogin || window.localStorage.getItem('isLoggedIn')) {
        await auth.login();
      } else {
        const { location } = history;
        const { pathname } = location;

        if (pathname !== '/') {
          const nonce = storeStateInSessionStorage({ location });
          auth.setAppState({ redirectNonce: nonce });
        }
        // redirect home
        history.replace('/');
      }
    };

    checkAuth();
  }, [forceLogin, history]);

  return (
    <div>
      <CallbackSpinner />
    </div>
  );
};

NotSignedIn.defaultProps = {
  forceLogin: false,
};

NotSignedIn.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }).isRequired,
  forceLogin: PropTypes.bool,
};

export default NotSignedIn;
